<template>
  <div
    :class="{
      addInfo: user?.role.permissions.pharmacy.update,
      'addInfo-disabled': !user?.role.permissions.pharmacy.update,
      tootip: !user?.role.permissions.pharmacy.update
    }"
  >
    <img src="@/assets/icons/Add.svg" alt="" />
    <span class="addInfo-span">{{ $t('add') }}</span>
    <span class="addInfo-span">{{ title }}</span>
    <span v-if="!user?.role.permissions.pharmacy.update" class="tooltiptext">
      {{ $t('enoughPermissions') }}
    </span>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { mapState } from 'vuex';

@Options({
  name: 'AddInfo',
  props: ['title'],
  computed: {
    ...mapState('account', ['user'])
  }
})
export default class AddInfoComponent extends Vue {}
</script>

<style lang="scss" scoped>
.addInfo {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: max-content;
  cursor: pointer;
  margin-bottom: 30px;
  img {
    margin-right: 10px;
  }
  .addInfo-span {
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    font-weight: 500;
    font-family: 'Ubuntu-Medium';
    color: $main-green;
    &:last-child {
      margin-left: 5px;
    }
  }
}

.tootip {
  position: relative;
  .tooltiptext {
    position: absolute;
    top: -30%;
    left: 68%;
    transform: translate(-50%, -100%);
    visibility: hidden;
    width: 150px;
    font-size: $elevenSize;
    line-height: $elevenSize;
    background: $label;
    color: $white;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: $label transparent transparent transparent;
    }
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}

.addInfo-disabled {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: max-content;
  margin-bottom: 30px;
  img {
    margin-right: 10px;
    filter: invert(77%) sepia(0%) saturate(64%) hue-rotate(138deg)
      brightness(97%) contrast(96%);
    background-color: rgb(225 82 64 / 0%);
  }
  .addInfo-span {
    font-size: $fourteenSize;
    line-height: $fourteenSize;
    font-weight: 500;
    font-family: 'Ubuntu-Medium';
    color: $grey;
    &:last-child {
      margin-left: 5px;
    }
  }
}
</style>
